module.exports = __webpack_public_path__ + "asset/img/heart.e0ec6a051c5b1b3774f783272a67ca5e.svg";